module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114137_93_157.3f5497e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114137_93_157.jpg
// module id = uYU5
// module chunks = 0